import { useCallback, useEffect, useState } from 'react';

import { unique } from '@revenuemarket/utils/arrayUtils';
import { MenuInfo, SelectInfo } from 'rc-menu/lib/interface';
import { CategoryTreeItem } from '~apis/categories';
import { FlattenTreeResult } from '~components/ui/HorizontalTreeTable/Table';

import SearchMenuList from './common/component/SearchMenuList';
import { SearchListProps } from './common/types';

const CategorySearchList: React.FC<SearchListProps<CategoryTreeItem>> = ({
  activeKey,
  searchValue,
  setActiveItem,
  excludeRoot,
  treeList,
  cashFlowType,
  disableActionOnInactiveItem = true,
  onSelectFinish,
  multiple = false,
}) => {
  const [selectedKey, setSelectedKey] = useState<(string | number)[] | null>(activeKey || null);

  const flattenedTree = treeList.filter((item) => {
    return (
      (excludeRoot ? item.depth > 0 : true) &&
      (cashFlowType ? item.value?.cashFlowType === cashFlowType : true) &&
      !item?.isDisabled &&
      item.status !== 'new'
    );
  });

  const searchResults = flattenedTree.filter((item) =>
    item.namePath?.toLocaleLowerCase()?.includes(searchValue?.toLocaleLowerCase().trim()),
  );

  const onSelect = useCallback(
    (item: SelectInfo | MenuInfo) => {
      setActiveItem(
        flattenedTree.find((i) => i.key === item.key) as FlattenTreeResult<CategoryTreeItem>,
      );
      if (multiple) {
        const selectedKey = unique([...(activeKey ?? []), item.key]);
        setSelectedKey(selectedKey);
      } else {
        setSelectedKey([item.key]);
      }

      onSelectFinish?.(item.key);
    },
    [activeKey, setActiveItem, flattenedTree, multiple, onSelectFinish],
  );

  useEffect(() => {
    if (activeKey) {
      setSelectedKey(activeKey);
    }
  }, [activeKey]);

  return (
    <SearchMenuList<CategoryTreeItem>
      onSelect={onSelect}
      searchResults={searchResults}
      selectedKey={selectedKey}
      disableActionOnInactiveItem={disableActionOnInactiveItem}
    />
  );
};

export default CategorySearchList;
